import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search.svg'
import _imports_1 from '@/assets/img/filter.svg'
import _imports_2 from '@/assets/img/management/add.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4db34d5f")

_pushScopeId("data-v-4db34d5f")
const _hoisted_1 = {
  class: "widePagePadding hasHeader hasFooter",
  ref: "scroll_section"
}
const _hoisted_2 = { class: "header d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "position-relative ms-3 me-2 d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "filtersAppliedCount"
}
const _hoisted_6 = { class: "twoBlocksContainer justify-content-between" }
const _hoisted_7 = { class: "infoContainer" }
const _hoisted_8 = { class: "text-uppercase fs_14 greyBlue ln_12 title" }
const _hoisted_9 = { class: "text-capitalize fs_14 orange d-block ln_12" }
const _hoisted_10 = { class: "fs_14 spaceCadet d-block ln_12 mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "fs_11 greyBlue d-block ln_12"
}
const _hoisted_12 = {
  key: 1,
  class: "fs_11 greyBlue d-block ln_12"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "adminButtonContainer spaceFromFooter rounded" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "searchContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/globalSearch')))
      }, [
        _hoisted_3,
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue ms-2",
          localizedKey: "app_globalSearchText",
          text: "Communities, eventi, fiere, brand..."
        })
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.filtersAppliedCount > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.filtersAppliedCount), 1))
          : _createCommentVNode("", true),
        _createVNode("img", {
          src: _imports_1,
          class: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilter()))
        })
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "block shadowRadiusCard discoverCard",
          key: item.identifier,
          onClick: ($event: any) => (_ctx.openDetail(item.type, item.slug))
        }, [
          _createVNode("div", {
            class: "backgroundImage",
            style: 'background-image: url(\'' + item.backgoundImageUrl + '\');'
          }, null, 4),
          _createVNode("div", {
            class: "logoImage",
            style: 'background-image: url(\'' + item.profileImageUrl + '\');'
          }, null, 4),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(item.title), 1),
            _createVNode("span", _hoisted_9, _toDisplayString(item.type), 1),
            _createVNode("span", _hoisted_10, _toDisplayString(item.category), 1),
            (item.dateRangeInfo)
              ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(item.dateRangeInfo), 1))
              : (_openBlock(), _createBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(item.subscribers) + " ", 1),
                  _createVNode(_component_localized_text, {
                    class: "ms-1",
                    localizedKey: "app_iscritti",
                    text: "iscritti"
                  })
                ]))
          ])
        ], 8, ["onClick"]))
      }), 128)),
      _createVNode("div", _hoisted_13, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, {
              key: 0,
              class: "my-4"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", {
        class: "managementButton",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCreateCommunity()))
      }, [
        _hoisted_15
      ])
    ])
  ], 512))
})